import { render, staticRenderFns } from "./CardCarregamentoColumn.vue?vue&type=template&id=155faef0&"
import script from "./CardCarregamentoColumn.vue?vue&type=script&lang=js&"
export * from "./CardCarregamentoColumn.vue?vue&type=script&lang=js&"
import style0 from "./CardCarregamentoColumn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFlex,VLayout})
